import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { StoreName } from 'app/enums/store';
import { UserEntity } from 'app/interfaces/entity';
import { setUser } from 'app/sentry';
import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { cancelationSubscribe } from 'app/services/api/utils';
import { SessionStoreStatus } from 'app/store/session/enums';
import { SessionState } from 'app/store/session/interfaces/session-state';
import { entityStoreStatus } from 'app/utils/store/entity-store-status';
import keycloak from '../../../keycloak';
import { UserStatus } from '@okletsplay/core';

export const getUserInfo = createAsyncThunk<UserEntity>(
  `${StoreName.Session}/getUserInfo`,
  (_, { signal }): Promise<UserEntity> => {
    const cancelToken = cancelationSubscribe(signal);

    return apiRequestCall<UserEntity, UserEntity>({
      params: {
        method: 'GET',
        resource: ApiResource.Users,
        urlPrefix: 'user-info',
        cancelToken,
      },
    });
  }
);

export const registerReducers = (builder: ActionReducerMapBuilder<SessionState>): void => {
  builder
    .addCase(getUserInfo.pending, (state, action) => {
      if (!state.entity.user) {
        setUser(null);
        entityStoreStatus.addRequestId(state, SessionStoreStatus.Loading, action.meta.requestId);
      }
    })
    .addCase(getUserInfo.fulfilled, (state, action) => {
      state.entity.user = action.payload as UserEntity;
      setUser(action.payload);
      entityStoreStatus.removeRequestId(state, SessionStoreStatus.Loading, action.meta.requestId);
      if (keycloak?.authenticated && action.payload.status === UserStatus.Banned) {
        keycloak.logout();
        window.localStorage.clear();
      }
    })
    .addCase(getUserInfo.rejected, (state, action) => {
      setUser(null);
      entityStoreStatus.removeRequestId(state, SessionStoreStatus.Loading, action.meta.requestId);
    });
};
